import React, { useState } from "react";
import { useAtom } from "jotai";
import { Formik } from "formik";
import { ReactComponent as Close } from "../../../assets/icons/icon-close.svg";
import "./styles.scss";
import Button from "../../../components/ButtonUI";
import Input from "../../../components/Input";
import { userAtom } from "../../../state/auth";
import { updateGroup } from "../../../api/groups";
import makeToast from "../../../components/Snackbar";
import { Link } from "react-router-dom";

interface IProps {
  openModal: Boolean;
  setOpenModal: Function;
  message?: String;
  type?: String;
  url?: string;
  setRefreshGroup: Function;
  setDoctorAdded?: boolean | any;
  setSelectedDoctor: Function | any;
  setDoctorData: Function;
  setOpenModalInfoDoctor?: Function;
}

const AddGroup: React.FC<IProps> = ({
  openModal,
  setOpenModal,
  setRefreshGroup,
  setSelectedDoctor,
  setDoctorData,
}) => {
  const [user, setUser] = useAtom(userAtom);
  const [copied, setCopied] = useState(false);
  
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <div className="fixed inset-0 z-50 outline-none focus:outline-none overflow-x-hidden overflow-y-auto bg-opacity-modal flexCenter">
      <div className="absolute bg-white z-40 top-1/3 flexCente cursusAdd w-1/2 p-8">
        <div className="relative">
          <div className="absolute right-0 mt-2 mr-2">
            <Button status="icon-secondary" onClick={() => setOpenModal(false)}>
              <Close />
            </Button>
          </div>
        </div>

        <Formik
          initialValues={{
            name: setSelectedDoctor?.name || "",
            freeRegistration: setSelectedDoctor?.freeRegistration || false,
          }}
          onSubmit={async (values) => {
            try {
              const response = await updateGroup({ ...values }, setSelectedDoctor._id);

              if (response.group) {
                makeToast("success", "Mise à jour des données du groupe effectuée avec succès.");
                setOpenModal(false);
                setRefreshGroup((x: any) => !x);
                setDoctorData(response.doctor);
              }
            } catch (err) {
              console.log("[error] add Group -on Submit :", err);
            }
          }}
        >
          {(props) => {
            const { values, handleChange, handleBlur, handleSubmit, setFieldValue } = props;

            return (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  setShowConfirm(true);
                }}
                className="flex-auto py-7 px-8 min-w-full"
              >
                {!showConfirm ? (
                  <>
                    <div className="flex flex-wrap items-baseline">
                      <h1 className="mb-10">Modifier le groupe</h1>
                    </div>
                    <div className="">
                      <Input
                        id="name"
                        placeholder="Ecrivez le nom du groupe ..."
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        inlineLabel={false}
                        className="w-full mb-6"
                      />
                      
                      {/* Link Section */}
                      <div className="mb-6">
                        <p>
                          Lien d'invitation :
                          <Link
                            className={copied ? "ml-1 copied-link" : "ml-1"}
                            to={`/register/${setSelectedDoctor._id}`}
                            onClick={(event) => {
                              event.preventDefault();
                              const link = `${window.location.origin}/register/${setSelectedDoctor._id}`;
                              navigator.clipboard.writeText(link);
                              setCopied(true);
                            }}
                          >
                            {`${window.location.origin}/register/${setSelectedDoctor._id}`}
                          </Link>
                        </p>
                      </div>

                      <div className="mb-8 flex items-center">
                        <input
                          id="freeRegistration"
                          type="checkbox"
                          checked={values.freeRegistration}
                          onChange={(event) => setFieldValue("freeRegistration", event.target.checked)}
                          className="form-checkbox h-5 w-5 text-blue-500"
                        />
                        <p className="ml-2 text-gray-700">Inscription gratuite</p>
                      </div>
                    </div>

                    <div className="flex justify-between">
                      <Button status="secondary" width="100px" height="50px" onClick={() => setOpenModal(false)}>
                        Annuler
                      </Button>
                      <Button type="submit" status="secondary" width="100px" height="50px">
                        Valider
                      </Button>
                    </div>
                  </>
                ) : (
                  /* 3. Confirmation View */
                  <div className="text-center py-4">
                    <h2 className="text-xl font-bold mb-6">Confirmation</h2>
                    <p className="mb-8">Êtes-vous sûr de vouloir modifier le nom de ce groupe ?</p>
                    <div className="flex justify-around">
                      <Button 
                        status="secondary" 
                        width="120px" 
                        height="50px" 
                        onClick={() => setShowConfirm(false)}
                      >
                        Annuler
                      </Button>
                      <Button 
                        status="primary" 
                        width="120px" 
                        height="50px" 
                        onClick={() => handleSubmit()}
                      >
                        Confirmer
                      </Button>
                    </div>
                  </div>
                )}
              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddGroup;
